<template>
    <div>
        <div class="text-h6 row items-center justify-center q-mb-sm">
            <q-icon name="mdi-calendar" size="sm" class="q-mr-xs" />Set Prefered License Expiry Date To:
        </div>
        <div class="row justify-center q-mb-md">
            <label style="font-size: 1.15rem; text-decoration-line: underline;">{{ month }} {{ day }}</label>
        </div>
        <div class="row justify-center">
            <q-date v-model="syncDate"
                    mask="YYYY/MM/DD"
                    minimal no-unset
                    @input="onDatePicked" />
        </div>
        <div class="q-mt-md row">
            <div class="col-auto q-pa-sm">
                <q-icon name="mdi-alert" size="sm" color="yellow-8" />
            </div>
            <div class="col text-caption q-px-sm">
                Changing this setting will clear your cart and any license renewal selections you've started. You'll need to restart any incomplete orders.
            </div>
        </div>
        <div class="row q-col-gutter-sm q-mt-md">
            <div class="col-xs-12 col-sm-auto">
                <q-btn label="Save" color="primary" class="full-width"
                       @click="updateExpirySyncDateSetting" />
            </div>
            <div class="col-xs-12 col-sm-auto">
                <q-btn flat label="Cancel" color="primary" v-close-popup class="full-width" @click="$emit('cancel')" />
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { format } from 'date-fns'

    export default {
        name: 'expiry-sync-date-editor',
        props: {
            expirySyncDateSetting: Object,
        },
        data() {
            return {
                DUMMY_YEAR: '2000',
                syncDate: null,
                month: null,
                day: null,
            }
        },
        methods: {
            updateExpirySyncDateSetting() {
                var date = new Date(this.syncDate)
                const m = String(date.getMonth() + 1).padStart(2, '0');
                const d = String(date.getDate()).padStart(2, '0');
                this.syncDate = `${this.DUMMY_YEAR}/${m}/${d}`;

                this.expirySyncDateSetting.settingValue = this.syncDate.toString();

                this.$store.dispatch('updateAccountSetting', this.expirySyncDateSetting).then(() => {
                    this.$emit('expirySyncDateSettingUpdated')
                })
            },
            setExpirySyncDateSettingDateVariables() {
                var date = new Date(this.expirySyncDateSetting?.settingValue || Date.now())
                const m = String(date.getMonth() + 1).padStart(2, '0');
                const d = String(date.getDate()).padStart(2, '0');
                this.syncDate = `${this.DUMMY_YEAR}/${m}/${d}`;

                this.updateMonthDayFromSyncDate();
            },
            onDatePicked(val) {
                this.syncDate = val;
                this.updateMonthDayFromSyncDate();
            },
            updateMonthDayFromSyncDate() {
                if (!this.syncDate) {
                    this.month = null;
                    this.day = null;
                    return;
                }

                var dateObj = new Date(this.syncDate);

                this.month = format(dateObj, 'MMMM');
                this.day = format(dateObj, 'd');
            },
        },
        computed: {
            ...mapState([
                'updateAccountSettingPending',
                'updateAccountSettingData',
            ]),
        },
        created() {
            this.setExpirySyncDateSettingDateVariables();
        },
    }
</script>
<style>
    .q-date__navigation {
        margin-bottom: 16px;
    }

        .q-date__navigation > .relative-position:nth-of-type(2) {
            /* Month Selector Btn */
            background-color: var(--q-color-primary) !important;
            color: #fff !important;
            border-radius: 4px;
        }

            .q-date__navigation > .relative-position:nth-of-type(2) > div {
                width: 100%;
            }

                .q-date__navigation > .relative-position:nth-of-type(2) > div > .q-btn {
                    width: 100%;
                }

        .q-date__navigation > .relative-position:nth-of-type(5) {
            /* Year Selector Btn */
            display: none;
        }

    .q-date__calendar-weekdays {
        display: none;
    }

    .q-date__arrow:nth-of-type(4),
    .q-date__arrow:nth-of-type(6) {
        /* Year Arrow Btns */
        display: none;
    }
</style>
